(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name PedidoService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('PedidoService', PedidoService);

    PedidoService.$inject = ["$http","$q","$window","$location"];

    function PedidoService($http,$q,$window,$location){  
       //console.log("app.aut Servicio ENABLE");

        var video = {
            finalizarPedidoVideoconsulta:finalizarPedidoVideoconsulta,
            finalizarPedidoAsesoramiento:finalizarPedidoAsesoramiento,
           
        };

        function finalizarPedidoVideoconsulta(result,vm){
        	//console.log("result",result);
        	//console.log("pedido",pedido);

        	var config = {
                headers : {
                }
            }
            
            return $http.post('/ajax/finalizarvideoconsulta', {
                "result":JSON.stringify(result), 
	            "pedido":JSON.stringify(vm.pedido),
	            "product_id":vm.product_id,
                "cupon":vm.cupon,
              
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };
        function finalizarPedidoAsesoramiento(result,vm){
            //console.log("result",result);
            //console.log("pedido",pedido);

            var config = {
                headers : {
                }
            }
            
            return $http.post('/ajax/finalizarasesoramiento', {
                "result":JSON.stringify(result), 
                //"pedido":JSON.stringify(vm.pedido),
                "product_id":vm.product_id,
                "cupon":vm.cupon,
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };
     
        return video;
    }

})();

